import { useMemo } from 'react'

const GridCard = ({
  index,
  handleCurrentGrid,
  active,
  answer,
  gridId,
  currentGridIndex,
  removeGrid,
  handleCloseGridsModal,
  isTablet,
}) => {
  const isCorrect = useMemo(() => {
    return active === answer
  }, [active, answer])

  return (
    <div className="relative h-fit">
      <div
        onClick={() => {
          handleCurrentGrid(index)
          if (isTablet) {
            handleCloseGridsModal()
          }
        }}
        className={`h-[60px] w-[40px] rounded-[8px] flex justify-center items-center border border-brd-primary flex-col relative !overflow-hidden cursor-pointer duration-300  ${
          currentGridIndex === index
            ? 'transform translate-y-[-10px] box-shadow-[0px_4px_8px_rgba(194,191,191,0.5)] border-primary'
            : ''
        }`}
      >
        <div
          className={`${
            active || active === 0 ? 'mb-[25px]' : ''
          }  font-bold text-[20px] text-over-ternary-background duration-300`}
        >
          {index + 1}
        </div>
        <div
          className={`${
            active || active === 0 ? '!bottom-[0px] !opacity-100' : ''
          } h-[25px] w-full absolute bottom-[-25px] opacity-0 duration-300 ${
            active !== null && answer !== undefined
              ? !isCorrect
                ? 'bg-error'
                : 'bg-correct'
              : 'bg-primary'
          }`}
        ></div>
      </div>
      {removeGrid ? (
        <div
          onClick={() => removeGrid(gridId)}
          className={`absolute cursor-pointer flex  items-center justify-center rounded-full text-center duration-300 transform w-4 h-4 text-[10px] bg-secondary-background text-over-ternary-background ${
            currentGridIndex !== index ? '-top-2' : '-top-4'
          } -right-2`}
        >
          <span>&times;</span>
        </div>
      ) : null}
    </div>
  )
}

export default GridCard
